import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const watchTowr = defineConnector({
  identifier: "watchTowr",
  name: "watchTowr",
  tagLine: "External attack surface management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(
      baseUrl || "https://your-tenant-id.sg.client.watchtowr.io/api/client"
    ),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up watchTowr",
      items: [
        {
          kind: "markdown",
          content:
            "Obtain an API token for your watchTowr tenant from your administrator and enter the tenant API URL below. Choose read access for the resources you need. See the [official SDK](https://github.com/watchtowr/watchtowr-api-sdk-python).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder:
            "https://your-tenant-id.sg.client.watchtowr.io/api/client",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Replace the documented Singapore-region example host with the tenant hostname for your watchTowr organization. Use the hostname shown by your watchTowr organization portal or provided by your watchTowr administrator; regional hosts may differ.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText: "An API token provisioned for your watchTowr tenant.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://your-tenant-id.sg.client.watchtowr.io/api/client")
          .trim()
          .replace(/\/+$/, "") + "/activity-log/list?page=1&page_size=1",
      ...{ method: "GET" },
    }),
  },
});
